<template>
  <div class="login-page">
    <van-form @submit="onSubmit">
      <label class="form-label">手机号</label>
      <van-field
        v-model="phone"
        maxlength="11"
        placeholder="请输入手机号"
      />
      <label class="form-label">验证码</label>
      <van-field
        v-model="verifyCode"
        maxlength="6"
        placeholder="请输入验证码"
      >
        <template #button>
          <Countdown
            :phone-num="phone"
            @get-code-success="getCodeSuccess"
          />
        </template>
      </van-field>
      <label class="form-label">新密码</label>
      <van-field v-model="password" name="password"
                 type="password"
                 placeholder="请输入新的密码"
      />
      <label class="form-label">重复密码</label>
      <van-field v-model="rePassword" name="rePassword"
                 type="password"
                 placeholder="请再次输入新的密码"
      />
      <div class="btn-box">
        <van-button round block class="save-btn" :disabled="disabled">
          确认
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Countdown from '../../../components/countdown/Countdown'
import { userModel } from '@/api/user'
import { REG } from '@/utils/constant'
export default {
  name: 'UpdatePwd',
  components: {
    Countdown
  },
  data() {
    return {
      phone:'',
      verifyCode: '',
      password: '',
      rePassword: '',
      hasGetCode: false
    }
  },

  computed: {
    disabled() {
      return !(this.phone && this.password && this.rePassword)
    }
  },

  methods: {
    getCodeSuccess() {
      this.hasGetCode = true
    },
    onSubmit() {
      if (!this.hasGetCode) {
        return this.$toast('请先获取验证码！')
      }
      if(!REG.PASSWORD_RED.test(this.password)){
        this.$toast({
          message:'密码必须含数字、大写字母、小写字母，长度6-15位！'
        })
        return false
      }
      if(this.password != this.rePassword){
        this.$toast({
          message:'新密码和重复密码输入不一致！'
        })
        return false
      }
      let params={
        "captcha": this.verifyCode,
        "password": this.password,
        "passwordAgain": this.rePassword,
        "phone": this.phone
      }
      userModel.forgetPwd(params).then(()=>{
        this.$dialog.alert({
          message: '修改密码成功,请重新登录！'
        }).then(() => {
          this.$router.push('/login')
        })
      })


    }
  }
}
</script>
<style scoped lang="less">
@import "../../../assets/styles/variable.less";
.form-label{
  display: block;
  margin-top: 40px;
  color: @dark-font-color;
}
.van-cell{
  padding-left: 0;
  padding-right: 0;
  &::after{
    border-bottom: 0;
  }
}
.mb68{
  margin-bottom: 68px;
}
.van-field{
  border-bottom: 1px solid #ddd;
}
.save-btn{
  width: 686px;
  height: 80px;
  font-size: 30px;
  color: #ffffff;
  background: #3A8AE5;
}
.login-page{
  padding: 0 32px;
  .title{
    margin-top:60px;
    margin-bottom: 24px;
    font-size: 36px;
    font-weight: bold;
    color: @dark-font-color;
  }
  .form{
    margin-top: 120px;
    .form-item{
      margin-top: 50px;
      .label{
        font-size: 30px;
        font-weight: bold;
        color: @dark-font-color;
      }
      .input{
        position: relative;
      }
    }

  }
  .btn-box{
    margin: 70px 0 24px;
    .disable{
      background: #B1D3FA;
    }
  }
}
</style>
